/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Job_TypeInputs */



/**
* | output |
* | --- |
* | "AD Generation" |
*
* @param {Ad_Job_TypeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_job_type = /** @type {((inputs?: Ad_Job_TypeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Job_TypeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Génération publicitaire")
	if (locale === "de") return /** @type {LocalizedString} */ ("AD-Generation")
	if (locale === "it") return /** @type {LocalizedString} */ ("Generazione di annunci pubblicitari")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Поколение AD")
	if (locale === "es") return /** @type {LocalizedString} */ ("Generación AD")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("广告生成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("広告生成")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एडी पीढ़ी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Geração de anúncios")
	return /** @type {LocalizedString} */ ("AD Generation")
});